module.exports = __webpack_public_path__ + "img/组 126@2x.e34a58b6.png";